'use client';

import { useEffect } from 'react';

export default function GoogleFontPreload() {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'style';
        link.href = 'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@100..900&display=swap';
        link.onload = () => {
            link.rel = 'stylesheet';
        };
        document.head.appendChild(link);
    }, []);

    return null;
}
